// extracted by mini-css-extract-plugin
export default {"heading":"LayoutItem_heading__1y+-M","horizontal":"LayoutItem_horizontal__eQ2V9","item-horizontal-0":"LayoutItem_item-horizontal-0__5iYko"};